import { UPDATED_START_FROM_SERVER } from 'messages'
import toastNotification from 'pug/toastNotification'
import { REGEX_START_DATE } from 'core/constants/regex'
import store from 'utils/store/withMiddleware'
import storage from 'proxy-storage'

function retryToUpdateStartDate(getPlans, [quoteResponse, ...rest]) {
  if (quoteResponse.hasError && REGEX_START_DATE.test(quoteResponse.description)) {
    let state = store.getState()

    if (quoteResponse.nextStartDate) {
      state.hcStorage.sdate = quoteResponse.nextStartDate
    }
    state.hcStorage.endDate = quoteResponse.nextEndDate
    // update new endDate
    state = store.update(state)
    storage.setItem('hc', state.hcStorage)

    return getPlans(state).then(response => {
      toastNotification(UPDATED_START_FROM_SERVER, 4000)

      return response
    })
  }

  return [quoteResponse, ...rest]
}

export default retryToUpdateStartDate
